import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Header from './Header';
import { useCart } from './CartContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const SinglepageFull = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [customize, setCustomize] = useState({ custom_description: '', custom_size: '' });
    const [isInCart, setIsInCart] = useState(false);

    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const { cartData, fetchCartData, openCart } = useCart();

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const res = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/viewsinglepage`, {
                    Product_Id: id
                });

                const prod = res.data?.ProductDetails?.[0]?.[0];
                // console.log("Fetched Product:", prod);

                setProduct(prod);
                //add
                // const cartItemsList = cartData?.AddToCartDetails?.[0] || [];

                // const cartItem = cartItemsList.find(item => item.Product_Id === prod?.Product_Id);
                // if (cartItem) {
                //     setQuantity(cartItem.Quantity);
                // }
                if (prod) {
                    setProduct(prod);

                    //add
                    const cartItemsList = cartData?.AddToCartDetails?.[0] || [];

                    const cartItem = cartItemsList.find(item => item.Product_Id === prod?.Product_Id);

                    if (cartItem) {
                        // setQuantity(cartItem.Quantity);
                        const cartQuantity = parseInt(cartItem.Quantity);
                        // console.log("Setting quantity from cart:", cartQuantity);
                        setQuantity(cartQuantity || 1);
                        setIsInCart(true);
                    }
                    else {
                        // ✅ Reset to 1 if not in cart
                        // console.log("Product not in cart, setting quantity to 1");
                        setQuantity(1);
                        setIsInCart(false);
                    }
                }
            } catch (err) {
                // console.error("Error fetching product:", err);
            }
        };

        if (id) fetchProduct();
    }, [id, cartData]);

    // const handleQuantityChange = (change) => {
    //     setQuantity((prev) => Math.max(1, prev + change));


    // };
    const handleQuantityChange = async (change) => {
        const newQty = Math.max(1, quantity + change);
        setQuantity(newQty);

        if (isInCart && user?.UserID && product) {
            try {
                await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, {
                    Product_ID: product.Product_Id,
                    Category_ID: product.Category_Id,
                    SubCategory_ID: product.SubCategory_Id,
                    Quantity: parseInt(newQty),
                    Customer_ID: user.UserID
                });

                await fetchCartData();
                // console.log("Cart updated in background");
            } catch (error) {
                // console.error('Error updating cart quantity:', error);
            }
        }
    };
    const handleCustomizeChange = (e) => {
        const { name, value } = e.target;
        setCustomize((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddToCart = async () => {
        // if (!product || !user) return;
        if (!product) return;

        // if (!user?.UserID) {
        //     toast.error('Please log in first'); //
        //     setTimeout(() => navigate('/login'), 1500); //
        //     return;
        // }
        if (!user?.UserID) {
    const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
    const idx = guestCart.findIndex(i => i.Product_Id === product.Product_Id);
    if (idx >= 0) {
        guestCart[idx].Quantity = quantity;
    } else {
        guestCart.push({
            Product_Id: product.Product_Id,
            Product_Name: product.Product_Name,
            Product_Img: product.Product_Img,
            Category_Id: product.Category_Id,
            SubCategory_Id: product.SubCategory_Id,
            Quantity: quantity,
        });
    }
    localStorage.setItem('guestCart', JSON.stringify(guestCart));
    toast.success('Added to cart!');
    fetchCartData();
    openCart();
    return;
}
        const customizePayload = {
            custom_description: customize.custom_description,
            custom_size: customize.custom_size,
            Product_Id: product.Product_Id
        };

        const cartPayload = {
            Product_ID: product.Product_Id,
            Category_ID: product.Category_Id,
            SubCategory_ID: product.SubCategory_Id,
            // Quantity: quantity,
            Quantity: parseInt(quantity),
            Customer_ID: user.UserID
        };

        try {
            setIsLoading(true);
            await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/addcustomize`, customizePayload);
            // await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/addtocart`, cartPayload);
            // await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, cartPayload);
            if (isInCart) {

                await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updatecartdetails`, cartPayload);
                toast.success('Cart updated successfully');
            } else {

                await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/addtocart`, cartPayload);
                toast.success('Added to cart successfully');
                setIsInCart(true);
            }
            await fetchCartData();
            openCart();

        } catch (error) {
            // console.error('Error during cart process:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!product) return <div style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;

    return (
        <>
            <Header />
            <div className="main-singlepagefull">
                <div className="singlepagefull-container">

                    {/* Left: Product Image */}
                    <div className="singlepagefull-image">
                        <img
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${product.Product_Img}`}
                            alt={product.Product_Name}
                        />
                    </div>

                    {/* Right: Product Details */}
                    <div className="singlepagefull-details">

                        {/* 1. Category & Subcategory Header */}
                        <div className="product-path">
                            <span>{product.category}</span>
                            <span className="separator">/</span>
                            <span>{product.SubCategory}</span>
                        </div>

                        {/* 2. Title */}
                        <h2>{product.Product_Name}</h2>

                        {/* 3. Description (No bold label) */}
                        <p className="product-remark">
                            {product.Remark}
                        </p>

                        {/* 4. Attribute Row (Size & Quantity) */}
                        <div className="product-attributes">
                            <div className="attribute-item">
                                <label>Dimensions</label>
                                <span>{product.Size}</span>
                            </div>

                            <div className="attribute-item">
                                <label>Quantity</label>
                                <div className="cart-qty-2">
                                    <button onClick={() => handleQuantityChange(-1)} disabled={quantity <= 1}>−</button>
                                    <span>{quantity}</span>
                                    <button onClick={() => handleQuantityChange(1)}>+</button>
                                </div>
                            </div>
                        </div>

                        {/* 5. Customization Fields */}
                        <div className="customize-section">
                            <div className="input-group">
                                <label>Customize Color / Description</label>
                                <textarea
                                    name="custom_description"
                                    value={customize.custom_description}
                                    onChange={handleCustomizeChange}
                                    placeholder="e.g. Add gold leafing or specific color tones..."
                                    className='customdesc'
                                    rows="1"
                                />
                            </div>

                            <div className="input-group">
                                <label>Customize Size</label>
                                <input
                                    type="text"
                                    name="custom_size"
                                    value={customize.custom_size}
                                    onChange={handleCustomizeChange}
                                    placeholder="e.g. 24x36 inches"
                                    className='customdesc'
                                />
                            </div>
                        </div>

                        {/* 6. Add to Cart Button */}
                        <button
                            onClick={handleAddToCart}
                            disabled={isLoading}
                            className="add-to-cart"
                        >
                            {isLoading ? 'Processing...' : 'Add to Cart'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SinglepageFull;